import { Endpoint } from '../api-interfaces';

export const STRATA_ADDITIONAL_INFO_STATIC_ENDPOINT: Endpoint = {
    api: '/api',
    url: () => '/strata-additional-info/',
};

export const UPCOMING_TRAINING_EVENTS_STATIC_ENDPOINT: Endpoint = {
    api: '/api',
    url: () => '/upcoming-training-events/',
};
